import { render } from "./RcsOnboardingNav.vue?vue&type=template&id=75f40b3b"
import script from "./RcsOnboardingNav.vue?vue&type=script&lang=ts"
export * from "./RcsOnboardingNav.vue?vue&type=script&lang=ts"
script.render = render

export default script